<template lang="pug">
  .d-serviceRules
    .topImg
      img(src="~assets/serviceRules/img1.png")
      .title 服务政策
    .tab
      .cont
        .item(v-for="(item,index) in tabDta", :key="index", :class='{activeClass: item.active}',@click="clickTab(index)") {{item.text}}
    .distribution(v-show="currentTab == 1")
      .title 配送安装范围
      .content 
        <span>·懂窝配送范围涵盖全国各地(除新疆、西藏、青海三省)。</span>
        <span>·大件家具提供免费配送服务,小件家居按城市距离分级,您可能需要承担不同金额的快递费。</span>
        <span>·全拆装大件家具在上海地区支持免费“送货上门及组装”服务(具体详情请治懂窝客服)。</span>
        <span>·悬挂灯具部分,目前尚未提供吊灯与顶棚的安装接电服务,敬请见谅。</span>
      .title 大件入户说明
      .content 
        <span>·大件家具的物流由懂窝甄选的第三方服务公司为您服务,服务公司或懂窝工作人员会与您致电预约上门时间,期间请保持电话通畅。</span>
        <span>·目前尚不支持指定时间上门服务,请您预估合理的收货时间,避免因到货后无法收货而产生的仓储费用,懂窝为您提供3个自然日的免费仓储,超过3个工作日开始收取仓储费。该笔费用将由物流公司直接向您收取,请您支付前仔细核对</span>
        <span>·若您的住所没有电梯或电梯无法使用,七楼及七楼以下,由懂窝合作的第三方公司给您免费提供上楼服务;若入户后有楼层或地下室的,则按抬楼楼层总数来计算费用。</span>
        <span>·因部分家具尺寸较大,请在购买前对楼梯、电梯、房门等入户结构进行尺寸测量,确认能否上楼入户。</span>
    .after-sales(v-show="currentTab == 2")
      .item
        .title 售后服务
        .content
          <span>·关于发货:一般情况下,生产周期为45-60天,具体请与客服沟通。</span>
          <span>·关于配送:全国大部分地区,包邮送货入户。无电梯或者电梯不可进情况下,七楼以上需颜外加收上楼费用。</span>
          <span> ·关于仓储:货物到达当地后,3日内免费仓储,超出后则按照10元/天/m³进行收费。</span>
          <span>·关于安装:请与在线客服关系,我们安排工人师傅与您孩约上门安装时间(免费安装)</span>
          <span> ·关于退换货:提供七天无理由退换货服务,如因用户原因产生退换货,则需支付10%-20%不等的耗损费。缺失包装,另需支<br/> 付5%-10%的费用。</span>
          <span> ·关于质保:所出售的大件家具产品,提供三年质保服务:非人为因素的商品损坏,提供免费维修服务</span>
      .item
        .title 三年质保服务
        .content
          <span>·懂窝为出售的家具产品提供为期三年的质量保障服务。质保期内，若产品在正常使用和维护的情况下出现问题，请第一时间联系懂窝客服，若属于产品本身质量问题(非人为原因),我们将为您维修,直至问题解决.质保期以产品实际签收日期为起始日,请您在签收货物单据时,注意查看交货日期。</span>
          <span>·质保期限内,若因产品质量问题而产生的售后相关费用,由懂窝承担;非产品质量问题,产生的售后相关费用,由客户承担。超出质保期限，懂窝将根据实际情况为您提供服务,并收取原材料成本、上门维修费等合理费用,具体金额将会在每次服务发生前与您商定。</span>
      .item
        .title 退换货政策
        .content
          <span>·甲方自签收之日起7天内，如因非产品本身质量问题等主观原因可以提出“七天无理由退换货”的申请。</span>
          <span>·由于家具属于定做的商品,甲方提出无理由退换货的，需支付相应耗损费。</span>
          <span>·若退换货订单中包含赠品,甲方需将赠品寄回,若赠品破损或遗失，需扣除赠品价值等额的货款。若您已经开具发票而发票遗失,则相应的退税点(13%)需由您承担。</span>
      .item
        .title 无法受理范围
        .content
          <span>·因拍摄设备 、显示器、光线等原因产生的色差,不属于商品质量问题</span>
          <span>·因商品测量标准不一致导致的尺寸问题,在相关标准规定的尺寸误差内,不属于商品质量问题;</span>
          <span>·材料，工艺产生的天然瑕疵,不属于商品质量问题</span>
          <span>·未按懂窝标准收货程序签收，拆包不当造成的损坏</span>
          <span>·未按照懂窝产品组装说明书操作，错误组装造成的产品损坏</span>
          <span>·未按照组装说明书要求，自行更换部件造成的损坏</span>
          <span>·自行拆装 、调换产品,或在错误的环境使用造成的损坏</span>
          <span>·非专业人士修理导致的损坏</span>
          <span>·由于不正当使用产品或部件造成的人身和财产损失</span>
          <span>·不能提供购买凭证或者擅自更改购买日期者</span>
          <span>·因其它不可抗拒力(地震,火灾)等造成的产品损坏</span>
          <span>·其它使用，维护，保管不当及人为损坏的情况</span>
          <span>·玻璃镜子发生霉变和雾光的三包期限为六个月。</span>
    .Q-A(v-show="currentTab == 3")
      .item
        .title 关于配送
        .content
          .lable Q：不同类型的家居，上楼配送安装是一样的费用嘛？
          <span>A：七楼及一下免费上楼，八层(含八层)起边几、茶几、餐桌、餐椅、床头柜等按15元/层/件计算;沙发、床垫、床、柜体(床头柜除外)、排骨架、大理石产品等按30元/层/件计算。若入户后有楼层或地下室的，则按抬楼楼层总数来计算费用。</span>
          .lable Q:如何预约上门时间？
          <span>A:懂窝目前尚不支持指定时间上门服务，请您预估合理的收货时间，避免到货后无法收货而产生仓储费用。</span>
          .lable Q:家具的配送范围？
          <span>A：懂窝配送范围覆盖全国各地，除新疆、西藏、青海三省。大件免费配送，小件按城市距离分级。</span>
          .lable Q：能免费上门组装嘛？
          <span>A:全拆大件家具，在上海地区支持免费“送货上门及组装”服务，详情可联系客服。</span>
          .lable Q：买的吊灯能帮忙安装吗？
          <span>A：懂窝目前尚未提供吊灯与顶棚的安装接电服务，敬请见谅。</span>
      .item
        .title 关于售后
        .content
          .lable Q:下单后多久能到货
          <span>A：家具为定做商品，一般情况下，生产周期为45-60天，具体请与客服沟通。</span>
          .lable Q：家具到家后不满意，我能退货吗？
          <span>A：甲方自签收之日起7天内，如因非产品本身质量问题等主观原因可以提出“七天无理由退换货”的申请。</span>
          .lable Q：家具使用时有损伤，怎么办？
          <span>A：我们为所出售的大件家具产品，提供三年质保服务，非人为因素的商品损坏，提供免费维修服务。</span>

</template>

<script>
export default {
  data() {
    return {
      tabDta: [
        {
          id: 1,
          text: "配送说明",
          active: true
        },
        {
          id: 2,
          text: "售后服务",
          active: false
        },
        {
          id: 3,
          text: "常见问题",
          active: false
        }
      ],
      currentTab: 1
    };
  },
  watch: {
    $route() {
      var currentTab = this.$route.query.currentTab;
      if (currentTab) {
        this.currentTab = this.$route.query.currentTab;
        this.tabDta.forEach((val, index) => {
          if (val.id == currentTab) {
            (val.active = true), (this.currentTab = currentTab);
          } else {
            val.active = false;
          }
        });
      }
    }
  },
  created () {
    var currentTab = this.$route.query.currentTab;
    if (currentTab) {
      this.currentTab = this.$route.query.currentTab;
      this.tabDta.forEach((val, index) => {
        if (val.id == currentTab) {
          (val.active = true), (this.currentTab = currentTab);
        } else {
          val.active = false;
        }
      });
    }
  },
  methods: {
    clickTab(i) {
      this.tabDta.forEach((val, index) => {
        if (i == index) {
          (val.active = true), (this.currentTab = val.id);
        } else {
          val.active = false;
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-serviceRules
  width: 100%
  box-sizing: border-box
  font-family: PingFangSC-Medium
  .topImg
    width: 100%
    position: relative
    img
      width: 100%
    .title
      margin: auto
      position: absolute
      left: 0
      right: 0
      top: 0
      bottom: 0
      z-index: 10
      width: r(252)
      height: r(80)
      font-size: r(62)
      color: #FFFFFF
  .tab
    margin: r(92) auto 0
    width: r(1370)
    height: r(62)
    border-top: 1px solid #CFD0D1
    border-bottom: 1px solid #CFD0D1
    .cont
      margin: 0 auto
      width: r(1120)
      height: 100%
      display: flex
      justify-content: space-between
      .item
        width: r(167)
        height: 100%
        font-size: r(36)
        color: #585858
        text-align: center
        line-height: r(62)
      .activeClass
        font-size: r(36)
        color: #070809
        border-bottom: r(3) solid #040506
  .distribution
    margin: 0 auto
    width: r(1120)
    padding-top: r(25)
    padding-bottom: r(375)
    .title
      margin-top: r(122)
      font-family: PingFangSC-Semibold
      font-size: r(32)
      color: #030304
      text-align: center
    .content
      margin-top: r(67)
      font-family: PingFangSC-Regular
      font-size: r(20)
      color: #373738
      line-height: r(34)
      text-align: center
      span
        display: block
        margin-top: r(30)
  .after-sales
    margin: 0 auto
    width: r(1120)
    padding-top: r(80)
    padding-bottom: r(142)
    .item
      margin-top: r(64)
      width: 100%
      padding-bottom: r(40)
      border-bottom: 1px solid #CFD0D1
      &:last-child
        border-bottom: none
      .title
        font-family: PingFangSC-Semibold
        font-size: r(32)
        color: #030304
        text-align: center
      .content
        font-family: PingFangSC-Regular
        font-size: r(20)
        color: #373738
        line-height: r(33)
        span
          display: block
          margin-top: r(30)
  .Q-A
    margin: 0 auto
    width: r(1120)
    padding-top: r(80)
    padding-bottom: r(142)
    .item
      margin-top: r(64)
      width: 100%
      padding-bottom: r(89)
      border-bottom: 1px solid #CFD0D1
      &:last-child
        border-bottom: none
      .title
        font-family: PingFangSC-Semibold
        font-size: r(32)
        color: #030304
        text-align: center
      .content
        font-family: PingFangSC-Regular
        font-size: r(20)
        color: #373738
        line-height: r(33)
        .lable
          margin-top: r(30)
          span
            color: #002727
</style>


// WEBPACK FOOTER //
// serviceRules.vue?13a2d0bc